"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.setMultiCurrency = exports.setCompanyCurrency = exports.fetchMultiCurrencies = exports.fetchCompanyCurrency = exports.fetchMultiCurrencyCodes = exports.fetchMultiCurrencyActive = exports.archiveMultiCurrency = void 0;

var _requestEntity = _interopRequireDefault(require("../requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("../RequestEpicDescriptor"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var MultiCurrencyAPI = _interopRequireWildcard(require("./API"));

var _reduxObservable = require("redux-observable");

var archiveMultiCurrency = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: MultiCurrencyAPI.archiveMultiCurrency,
  initiatingActionType: _actions.MultiCurrencyActionTypes.ARCHIVE_MULTI_CURRENCY,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.ArchiveMultiCurrency
}));
exports.archiveMultiCurrency = archiveMultiCurrency;
var fetchMultiCurrencyActive = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: MultiCurrencyAPI.fetchMultiCurrencyActive,
  initiatingActionType: _actions.MultiCurrencyActionTypes.FETCH_MULTI_CURRENCY_ACTIVE,
  requestStatusSelector: _selectors.getFetchMultiCurrencyActiveRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchMultiCurrencyActive
}));
exports.fetchMultiCurrencyActive = fetchMultiCurrencyActive;
var fetchMultiCurrencyCodes = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: MultiCurrencyAPI.fetchMultiCurrencyCodes,
  initiatingActionType: _actions.MultiCurrencyActionTypes.FETCH_MULTI_CURRENCY_CODES,
  requestStatusSelector: _selectors.getFetchMultiCurrencyCodesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchMultiCurrencyCodes
}));
exports.fetchMultiCurrencyCodes = fetchMultiCurrencyCodes;
var fetchCompanyCurrency = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: MultiCurrencyAPI.fetchCompanyCurrency,
  initiatingActionType: _actions.MultiCurrencyActionTypes.FETCH_HOME_CURRENCY,
  requestStatusSelector: _selectors.getFetchCompanyCurrencyRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchCompanyCurrency
}));
exports.fetchCompanyCurrency = fetchCompanyCurrency;
var fetchMultiCurrencies = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: MultiCurrencyAPI.fetchMultiCurrencies,
  initiatingActionType: _actions.MultiCurrencyActionTypes.FETCH_MULTI_CURRENCIES,
  requestStatusSelector: _selectors.getFetchMultiCurrenciesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchMultiCurrencies
}));
exports.fetchMultiCurrencies = fetchMultiCurrencies;
var setCompanyCurrency = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: MultiCurrencyAPI.setCompanyCurrency,
  initiatingActionType: _actions.MultiCurrencyActionTypes.SET_HOME_CURRENCY,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.SetCompanyCurrency
}));
exports.setCompanyCurrency = setCompanyCurrency;
var setMultiCurrency = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: MultiCurrencyAPI.setMultiCurrency,
  initiatingActionType: _actions.MultiCurrencyActionTypes.SET_MULTI_CURRENCY,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.SetMultiCurrency
}));
exports.setMultiCurrency = setMultiCurrency;

var _default = (0, _reduxObservable.combineEpics)(archiveMultiCurrency, fetchMultiCurrencyCodes, fetchMultiCurrencyActive, fetchCompanyCurrency, fetchMultiCurrencies, setCompanyCurrency, setMultiCurrency);

exports.default = _default;